import { styles } from './styles';
import Heading from '../../../../sharedComponents/heading';
import {
  RACE_OPTIONS,
  ETHNICITY_OPTIONS,
  MILITARY_OPTIONS
} from '../../../../utils/constants';
import Dropdown from '../../../../sharedComponents/dropdown';
import DropdownItem from '../../../../sharedComponents/dropdownItem';

interface IDemographics {
  watch: any;
  errors: any;
  handleDropdown: (e: React.ChangeEvent, dropdownName: any) => void;
}

const Demographics = ({ watch, errors, handleDropdown }: IDemographics) => {
  const classes = styles();

  return (
    <div>
      <Heading name="Demographics" />
      <div className={classes.inputsContainer}>
        <Dropdown
          multiple
          selectedItem={watch('race')}
          errorMsg={errors.race?.message}
          label="What is the patient's race?*"
          customSelectClass={classes.customInput}
          handleItems={e => handleDropdown(e, 'race')}
        >
          {RACE_OPTIONS.map(({ id, name }) => (
            <DropdownItem key={id} value={id}>
              {name}
            </DropdownItem>
          ))}
        </Dropdown>
        <Dropdown
          multiple
          selectedItem={watch('ethnicity')}
          label="Is the patient of Hispanic, Latino, or Spanish origin?"
          customSelectClass={classes.customInput}
          handleItems={e => handleDropdown(e, 'ethnicity')}
        >
          {ETHNICITY_OPTIONS.map(({ id, name }) => (
            <DropdownItem key={id} value={id}>
              {name}
            </DropdownItem>
          ))}
        </Dropdown>
        <Dropdown
          multiple
          selectedItem={watch('militaryStatus')}
          errorMsg={errors.militaryStatus?.message}
          label="What’s your military status?"
          customSelectClass={classes.customInput}
          handleItems={e => handleDropdown(e, 'militaryStatus')}
        >
          {MILITARY_OPTIONS.map(({ id, name }) => (
            <DropdownItem key={id} value={id}>
              {name}
            </DropdownItem>
          ))}
        </Dropdown>
      </div>
    </div>
  );
};

export default Demographics;
